import React from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import useIframeResize from "src/hooks/useIframeResize";
import useDevice from "src/hooks/useDevice";

const PowerBiEmbedProgrammaticFiltering = ({ content, workspaceDetails, site, user }) => {
  useIframeResize({ workspaceDetails, site, user });
  const device = useDevice();

  const maxWidth = localStorage.getItem("impersonatedUserId") ? workspaceDetails?.max_width : "100%";

  return (
    <div className="relative h-full w-full">
      {content?.embedUrl && (
        <div
          className="mx-auto h-full w-full overflow-auto"
          style={{ maxWidth }}>
          <PowerBIEmbed
            embedConfig={{
              type: content?.embed_type === "EMBED_PAGE" ? "dashboard" : "report",
              id: content?.embed_id,
              embedUrl: content?.embedUrl,
              accessToken: content?.embedToken,
              tokenType: models.TokenType.Embed,
              settings: {
                layoutType: device === "mobile" || device === "mobilePortrait" ? models.LayoutType.MobilePortrait : models.LayoutType.Custom,
                customLayout: {
                  displayOption: models.DisplayOption.FitToWidth,
                },
                panes: {
                  filters: { visible: false },
                  pageNavigation: { visible: false },
                },
                background: models.BackgroundType.Transparent,
              },
            }}
            cssClassName="w-full h-full"
            getEmbeddedComponent={(embeddedReport) => {
              embeddedReport.on("loaded", async () => {
                try {
                  window.dispatchEvent(new CustomEvent("domo:iframe-loaded", {}));
                  await embeddedReport.setFilters(content?.filters || []);
                } catch (error) {}
              });
            }}
          />
        </div>
      )}
    </div>
  );
};

export default PowerBiEmbedProgrammaticFiltering;
